import React, { useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Banner from './Banner';
import SelectedWorks from './SelectedWorks';
import PageFooter from './PageFooter';

const PortfolioContainer = styled.div`
  min-height: 100vh;
  background: var(--bg);
`;

const RecruiterPortfolio = () => {
  const containerRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const y = location.state?.restoreScrollY;
    if (typeof y !== 'number' || Number.isNaN(y)) return;

    const applyScroll = () => window.scrollTo(0, y);
    applyScroll();
    requestAnimationFrame(() => {
      requestAnimationFrame(applyScroll);
    });

    navigate(`${location.pathname}${location.search}`, { replace: true, state: {} });
  }, [location.pathname, location.search, location.state, navigate]);

  return (
    <PortfolioContainer ref={containerRef}>
      <Banner />
      <SelectedWorks />
      <PageFooter />
    </PortfolioContainer>
  );
};

export default RecruiterPortfolio;
